/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    form?: unknown;
  };
}

import Component from "@glimmer/component";

const pancreaticMutations = [
  "brca1",
  "brca2",
  "palb2",
  "kras",
  "atm",
  "fanc-c",
  "prss1",
  "p16/cdkn2a",
  "lkb1/stk11",
  "mlh1",
  "msh2",
  "msh6",
  "pms2"
];

export default class MedicalHistoryFormPancreaticCancerPathologyComponent extends Component<Signature> {
  get pancreaticMutations(): string[] {
    return pancreaticMutations;
  }
}
